import { geometry } from 'app/contracts/Geometry';
import { particles } from 'app/contracts/Particles';
import { ParticleBehaviour } from '../ParticleBehaviour';

export class ParticleHover extends ParticleBehaviour {
	private _target: particles.ParticleTarget;
	private _center: geometry.Vector2;
	private _distance: number;
	private _ratio: number;
	private _radius: number = 50;
	private _alpha: any = {
		min: 1,
		max: 1
	};

	private _scale: any = {
		min: 1,
		max: 1
	};

	public set target(target: particles.ParticleTarget) {
		this._target = target;
	}

	public start(): void {
		this.active = true;
	}

	public set radius(radius: number) {
		this._radius = radius;
	}

	public setAlpha(min: number, max: number) {
		this._alpha = {
			min: min,
			max: max
		};
	}

	public setScale(min: number, max: number) {
		this._scale = {
			min: min,
			max: max
		};
	}

	public tick(): void {
		if (!this._target) {
			return;
		}

		this._center = this._target.position;
		this._animatedProps.tick();
		this._distance = Math.hypot(this._animatedProps.x - this._center.x, this._animatedProps.y - this._center.y);

		if (this._distance < this._radius) {
			this._ratio = 1 - this._distance / this._radius;
			this._animatedProps.targetAlpha = this._alpha.min + (this._alpha.max - this._alpha.min) * this._ratio;
			this._animatedProps.targetScale = this._scale.min + (this._scale.max - this._scale.min) * this._ratio;
		} else {
			this._animatedProps.targetAlpha = this._alpha.min;
			this._animatedProps.targetScale = this._scale.min;
		}
	}
}
